import React, { useState } from 'react';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img src="/logo_lexis.svg" alt="Lexis" className="h-8 w-auto" />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:block">
            <div className="flex items-center space-x-8">
              <a href="https://www.lexis.com.ec/planes" className="text-gray-600 hover:text-primary-500 text-sm font-medium transition-colors" target="_blank" rel="noopener noreferrer">
                Precios
              </a>
              <a href="https://www.lexis.com.ec/blog" className="text-gray-600 hover:text-primary-500 text-sm font-medium transition-colors" target="_blank" rel="noopener noreferrer">
                Blog
              </a>
              <a href="https://www.lexis.com.ec/noticias" className="text-gray-600 hover:text-primary-500 text-sm font-medium transition-colors" target="_blank" rel="noopener noreferrer">
                Noticias
              </a>
              <a href="https://www.lexis.com.ec/biblioteca" className="text-gray-600 hover:text-primary-500 text-sm font-medium transition-colors" target="_blank" rel="noopener noreferrer">
                Biblioteca
              </a>
              <a href="https://www.lexis.com.ec/contacto" className="text-gray-600 hover:text-primary-500 text-sm font-medium transition-colors" target="_blank" rel="noopener noreferrer">
                Contacto
              </a>
            </div>
          </div>

          {/* Auth Buttons */}
          <div className="hidden lg:flex items-center space-x-4">
            <a href="https://www.lexis.com.ec/usuario/iniciar-sesion" className="text-gray-600 hover:text-primary-500 text-sm font-medium transition-colors" target="_blank" rel="noopener noreferrer">
              Iniciar sesión
            </a>
            <a href="https://www.lexis.com.ec/usuario/crear-cuenta" className="bg-primary-500 hover:bg-primary-600 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors" target="_blank" rel="noopener noreferrer">
              Registrate
            </a>
            <a href="https://www.lexis.com.ec/tienda" className="text-gray-600 hover:text-primary-500 p-2" target="_blank" rel="noopener noreferrer">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-1.5 6M7 13l-1.5-6M17 21a2 2 0 100-4 2 2 0 000 4zM9 21a2 2 0 100-4 2 2 0 000 4z" />
              </svg>
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="bg-gray-50 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
            >
              <span className="sr-only">Abrir menú principal</span>
              {!isMenuOpen ? (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              ) : (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
              <a href="https://www.lexis.com.ec/planes" className="text-gray-600 hover:text-primary-500 block px-3 py-2 rounded-md text-base font-medium" target="_blank" rel="noopener noreferrer">
                Precios
              </a>
              <a href="https://www.lexis.com.ec/blog" className="text-gray-600 hover:text-primary-500 block px-3 py-2 rounded-md text-base font-medium" target="_blank" rel="noopener noreferrer">
                Blog
              </a>
              <a href="https://www.lexis.com.ec/noticias" className="text-gray-600 hover:text-primary-500 block px-3 py-2 rounded-md text-base font-medium" target="_blank" rel="noopener noreferrer">
                Noticias
              </a>
              <a href="https://www.lexis.com.ec/biblioteca" className="text-gray-600 hover:text-primary-500 block px-3 py-2 rounded-md text-base font-medium" target="_blank" rel="noopener noreferrer">
                Biblioteca
              </a>
              <a href="https://www.lexis.com.ec/contacto" className="text-gray-600 hover:text-primary-500 block px-3 py-2 rounded-md text-base font-medium" target="_blank" rel="noopener noreferrer">
                Contacto
              </a>
              <div className="pt-4 space-y-2">
                <a href="https://www.lexis.com.ec/usuario/iniciar-sesion" className="text-gray-600 hover:text-primary-500 block px-3 py-2 rounded-md text-base font-medium" target="_blank" rel="noopener noreferrer">
                  Iniciar sesión
                </a>
                <a href="https://www.lexis.com.ec/usuario/crear-cuenta" className="bg-primary-500 hover:bg-primary-600 text-white w-full block text-center px-4 py-2 rounded-md text-sm font-medium transition-colors" target="_blank" rel="noopener noreferrer">
                  Registrate
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
